import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const DRAWER_TOOLBAR_CLASS_NAME = 'DrawerToolbar';
export const DRAWER_TOOLBAR_CLASS_SLOTS = ['root', 'title', 'toggle'] as const;

export type DrawerToolbarClassSlot =
	(typeof DRAWER_TOOLBAR_CLASS_SLOTS)[number];

export interface DrawerToolbarClasses {
	root: string;
	title: string;
	toggle: string;

	anchorLeft: string;
	anchorRight: string;
	open: string;
}

export type DrawerToolbarClassKey = keyof DrawerToolbarClasses;

export const getDrawerToolbarUtilityClass = (slot: string) =>
	generateUtilityClass(DRAWER_TOOLBAR_CLASS_NAME, slot);

export const drawerToolbarClasses: DrawerToolbarClasses =
	generateUtilityClasses(DRAWER_TOOLBAR_CLASS_NAME, [
		'root',
		'anchorLeft',
		'anchorRight',
		'open',
		'title',
		'toggle',
	]);

export default drawerToolbarClasses;
